import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import { RestrictedComponent } from '../../app/components/RestrictedComponent.tsx';
import { OperatorAppRoutes } from '../../app/config/OperatorRoutingConfig.tsx';
import { CustomPermissionCheckers } from '../../app/state/Permission.ts';
import { Translation } from '../../common/i18n/Text.ts';
import * as CurrentOperatorLoginState from '../../common/state/CurrentOperatorLoginState.ts';
import * as OperatorDataState from '../../common/state/OperatorDataState.ts';
import { Body, Container, TabItem, Tabs } from '../../ui/layout/TabContent.tsx';
import { texts } from '../i18n/CustomerAccountsTexts.tsx';
import * as CustomerAccountState from '../state/CustomerAccountState.ts';
import { CustomerClearanceCreateSlideIn } from './CustomerClearanceCreateSlideIn.tsx';
import { CustomerClearanceDetailSlideIn } from './CustomerClearanceDetailSlideIn.tsx';
import { CustomerClearanceTable } from './CustomerClearanceTable.tsx';
import { PermitTypeSelectionSlideIn } from './PermitTypeSelectionSlideIn.tsx';

export interface Texts {
    CustomerNr: Translation;
    Name: Translation;
    Company: Translation;
    Active: Translation;
    Locked: Translation;
    Balance: Translation;
    PaymentType: Translation;
    ActivatedOn: Translation;
    LockedValue: Translation;
    NotLockedValue: Translation;
    DetailHeader: Translation;

    CustomerSearchTitle: Translation;
    CustomerWhitelistTitle: Translation;
}

export function CustomerAccounts() {
    const { storeState } = useStore(store => {
        const filter = CustomerAccountState.Filter.get(store);

        return {
            layout: CustomerAccountState.Layout.get(store),
            list: CustomerAccountState.List.get(
                store,
                filter.search &&
                    CustomerAccountState.Filter.searchActive(filter)
                    ? {
                          search: filter.search,
                      }
                    : null,
            ),
            filter,
            operatorData: OperatorDataState.get(store),
            currentLogin: CurrentOperatorLoginState.get(store),
        };
    });
    const { language } = useLanguage();

    const operator = storeState.operatorData.data;
    const currentLogin = storeState.currentLogin.data;

    return (
        <Container>
            <Tabs>
                {isDefined(operator) && isDefined(currentLogin) ? (
                    <RestrictedComponent
                        route={OperatorAppRoutes.CustomerAccounts}
                        permissionChecker={
                            CustomPermissionCheckers.customerWhitelistAllowed
                        }
                    >
                        <TabItem
                            active={true}
                            description={texts[
                                language
                            ].CustomerWhitelistTitle()}
                            onClick={null}
                        />
                    </RestrictedComponent>
                ) : undefined}
            </Tabs>
            <Body
                disabled={false}
                dependingStateSlices={[storeState.list]}
                slideIns={
                    <div>
                        <CustomerClearanceCreateSlideIn />
                        <CustomerClearanceDetailSlideIn />
                        <PermitTypeSelectionSlideIn />
                    </div>
                }
            >
                <CustomerClearanceTable />
            </Body>
        </Container>
    );
}
